const getQuestionEventsMetadata = (cancerType) => {
  const cancer_type = window.t(`quest_selector.cancer_types.${cancerType}`);
  const page_location = window.location.href;

  return {
    cancer_type,
    page_location,
  };
};

export {
  getQuestionEventsMetadata,
};
